import { InlineCalendar } from "PFComponents/calendar/inline_calendar";
import { Modal } from "PFComponents/modal";
import { isDatePassed, utc } from "PFCore/helpers/date";
import { useActivityReviewDeadlineCreate } from "PFCore/hooks/queries/activity/use_activity_deadline_create";
import { useActivityReviewDeadlineUpdate } from "PFCore/hooks/queries/activity/use_activity_deadline_update";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useCurrentActivity } from "../../hooks/use_current_activity";

type AddDeadlineModalProps = {
  onClose: () => void;
};

export const DeadlineModal = ({ onClose }: AddDeadlineModalProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.shortlist.review" });
  const growlErrors = useErrorsGrowl();
  const { formatISODate } = useDateFormatter();
  const activity = useCurrentActivity();

  const isEditMode = activity.review?.deadline;

  const { mutate: updateReviewDeadline } = useActivityReviewDeadlineUpdate({
    onError: (error) => growlErrors(error)
  });
  const { mutate: createReviewDeadline } = useActivityReviewDeadlineCreate({
    onError: (error) => growlErrors(error)
  });

  const [deadlineDate, setDeadlineDate] = useState<string | null>(activity.review?.deadline || null);

  const deadlinePassed = isDatePassed(deadlineDate);

  const handleSubmit =
    deadlineDate && deadlineDate !== activity.review?.deadline
      ? () =>
          (isEditMode ? updateReviewDeadline : createReviewDeadline)({ id: activity.id, date: deadlineDate })
      : undefined;

  return (
    <Modal title={t("reviewIsReady")} labelOK={t("notifyReviewer")} onOK={handleSubmit} onClose={onClose}>
      <InlineCalendar
        label={t("reviewDeadline")}
        selectedDate={deadlineDate ? formatISODate(deadlineDate) : null}
        minDate={formatISODate(utc().startOf("day").add(1, "days"))}
        qaId={"review-deadline-date"}
        handleChange={setDeadlineDate}
        required
        warning={deadlinePassed && t("deadlinePassed")}
      />
    </Modal>
  );
};
